import { request } from "./request";

export function insert(name, nameEn, role, grade, position, positionEn, info, infoEn, imgLength) {
  return request({
    url: '/instruct/insert',
    params: { name, nameEn, role, grade, position, positionEn, info, infoEn, imgLength }
  })
}

export function deleteInstruct(id) {
  return request({
    url: '/instruct/delete',
    params: { id }
  })
}

export function modify(id, name, nameEn, role, grade, position, positionEn, info, infoEn, imgLength) {
  return request({
    url: '/instruct/modify',
    params: { id, name, nameEn, role, grade, position, positionEn, info, infoEn, imgLength}
  })
}

export function query(role) {
  return request({
    url: '/instruct/query',
    params: { role }
  })
}

export function queryAll(startIndex, length) {
  return request({
    url: '/instruct/queryAll',
    params:{
      startIndex,
      length
    }
  })
}

export function queryEntire(start) {
  return request({
    url: '/instruct/queryEntire',
  })
}

export function totalIns() {
  return request({
    url: '/instruct/totalIns',
  })
}